import { render, staticRenderFns } from "./product-basic-info.vue?vue&type=template&id=6a29efc1"
import script from "./product-basic-info.vue?vue&type=script&lang=js"
export * from "./product-basic-info.vue?vue&type=script&lang=js"
import style0 from "./product-basic-info.vue?vue&type=style&index=0&id=6a29efc1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports